import script from "./IntroductionSection.vue?vue&type=script&setup=true&lang=js"
export * from "./IntroductionSection.vue?vue&type=script&setup=true&lang=js"

import "./IntroductionSection.vue?vue&type=style&index=0&id=fcbc67dc&scoped=true&lang=css"

import exportComponent from "/Users/tycooper/Desktop/Coding/Suites/barkbadge/barkbadge-wholesale/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fcbc67dc"]])

export default __exports__